import { domainChecker } from "../utils/helpers/logicHelper";
import { subDomainMapper } from "../utils/mapper/mappers";

export const DEFAULT_BASEURL = "test-luaa";
export const TEST_BASEURL = "test-luaa";
export const PROD_BASEURL = "luaa";
export const LOCALHOST_BASEURL = "localhost";

export const getSubDomain = () => {
  const subDomainUrl = window.location.hostname.split(".")[0];
  return subDomainUrl === LOCALHOST_BASEURL ||
    subDomainUrl === TEST_BASEURL ||
    subDomainUrl === PROD_BASEURL
    ? DEFAULT_BASEURL
    : subDomainUrl;
};

export const fetchSubDomain = () => {
  const subDomainUrl = getSubDomain();
  const subDomainChecker = domainChecker(window.location.hostname);

  return subDomainUrl === DEFAULT_BASEURL
    ? subDomainMapper["TEST"]
    : subDomainChecker
    ? subDomainMapper[subDomainUrl.toUpperCase()]
    : "nothing here";
};

export const getBaseUrl = () => {
  const subDomainObject = fetchSubDomain();
  if (subDomainObject.subDomain === LOCALHOST_BASEURL) {
    return `https://${subDomainObject.subDomain}${subDomainObject.api_env.env}`;
  }
  // return "https://localhost:8081";
  return `https://${subDomainObject.subDomain}.${subDomainObject.api_env.env}`;
};
